// ตำแหน่งทุกอย่างบนกระดาษคำตอบ หน่วยเป็นมิลลิเมตรบน A4 (210 x 297)
//
// ไฟล์นี้เป็นสัญญาระหว่าง "ตัวพิมพ์" กับ "ตัวอ่าน" (ขั้นสแกน) — ทั้งสองต้องเรียกฟังก์ชันเดียวกันนี้
// ห้ามเขียนตัวเลขตำแหน่งซ้ำที่อื่น และห้ามแก้ตัวเลขของแบบที่เคยพิมพ์ไปแล้ว (อาจยังมีแผ่นรอสแกน)
// ถ้าต้องเปลี่ยนแบบกระดาษ ให้เพิ่มแบบใหม่ใน GEOMETRY แล้วขึ้น LAYOUT_VERSION — ของเดิมเก็บไว้ทั้งหมด
//
// ตัวอ่านไม่ต้องรู้ล่วงหน้าว่าแผ่นเป็นแบบไหน: ลองจัดภาพด้วยสี่เหลี่ยมมุมของทุกแบบ (LAYOUT_VERSIONS)
// แบบที่ถอดแถบรหัสผ่าน CRC คือแบบที่ถูก (ดู reader.readSheet) — ตัวเลข "แบบ N" ที่พิมพ์ใต้แถบ
// มีไว้ให้คนอ่านเท่านั้น
//
// ตัวอ่านจัดภาพให้ตรงจากศูนย์กลางสี่เหลี่ยมทึบสี่มุม (markers) แล้วอ่านทุกช่องด้วยพิกัดจากที่นี่
// ตำแหน่งข้อจึงขึ้นกับ "ลำดับของข้อปรนัย" เท่านั้น (ข้ออัตนัยไม่มีช่องฝน) — โครงข้อสอบถูกล็อก
// ทันทีที่มีคำตอบด้วยเหตุผลนี้ (ดู examModel.updateExam)
import { CODE_BITS } from './sheetCode'

export const PAGE = { width: 210, height: 297 }

// ── แบบกระดาษ ────────────────────────────────────────────────────────────────
// แบบ 1: สี่เหลี่ยมมุมห่างขอบกระดาษ 10 มม. ทุกด้าน
// แบบ 2: เผื่อที่เย็บ — ผู้คุมสอบเย็บมุมขวาบน (บางคนมุมซ้ายบน/ขอบซ้าย) แล้วลวดเย็บบังสี่เหลี่ยมมุม
//        แผ่นนั้นจะสแกนไม่ได้เลย สี่เหลี่ยมมุมบนทั้งสองจึงห่างขอบบน 24 มม. และมุมซ้ายห่างขอบซ้าย 24 มม.
//        หัวกระดาษอยู่เหนือแนวสี่เหลี่ยมมุมบน ส่วนที่เหลือเลื่อนลง 4 มม. และขยับเข้าจากซ้าย (คอลัมน์แคบลง)
//        ขอบล่าง/ขวาเท่าเดิม
// box = ขอบบนของกรอบข้อมูลนักเรียน / codeY0 = แถวบนของแถบรหัส / gridY0 = ศูนย์กลางแถวแรกของช่องฝน
const GEOMETRY = {
  1: { markerLeft: 10, markerTop: 10, gridX0: 16, gridY0: 78, columnWidth: 44.5, bubbleX0: 12.5, bubblePitch: 6.5,
    codeCenterX: PAGE.width / 2, codeY0: 52, frame: { left: 18, right: 192, box: 30 } },
  2: { markerLeft: 24, markerTop: 24, gridX0: 30, gridY0: 82, columnWidth: 41.5, bubbleX0: 12, bubblePitch: 6.2,
    codeCenterX: 113, codeY0: 56, frame: { left: 32, right: 194, box: 34 } },
}

export const LAYOUT_VERSION = 2                 // แบบที่พิมพ์ตอนนี้
export const LAYOUT_VERSIONS = [2, 1]           // แบบที่ตัวอ่านรู้จัก (ลองตามลำดับนี้)

const geo = (version) => {
  const g = GEOMETRY[version]
  if (!g) throw new Error(`ไม่รู้จักกระดาษคำตอบแบบ ${version}`)
  return g
}

// ตำแหน่งของเนื้อหาที่ไม่ได้ถูกอ่าน (หัวกระดาษ กรอบข้อมูลนักเรียน คำชี้แจง) — ตัวพิมพ์ใช้จัดตำแหน่ง
// { left, right, box: ขอบบนของกรอบข้อมูล, code: แถวบนของแถบรหัส, grid: แถวแรกของช่องฝน }
export const frameFor = (version = LAYOUT_VERSION) => {
  const g = geo(version)
  return { ...g.frame, code: g.codeY0, grid: g.gridY0 }
}

const MARKER = 7
export const markersFor = (version = LAYOUT_VERSION) => {
  const { markerLeft: left, markerTop: top } = geo(version)
  const right = PAGE.width - 10 - MARKER
  return [
    { corner: 'tl', x: left, y: top, size: MARKER },
    { corner: 'tr', x: right, y: top, size: MARKER },
    { corner: 'bl', x: left, y: PAGE.height - 10 - MARKER, size: MARKER },
    { corner: 'br', x: right, y: PAGE.height - 10 - MARKER, size: MARKER },
  ]
}
export const MARKERS = markersFor(LAYOUT_VERSION)

// แถบรหัสแผ่น 2 แถว แถวละ 26 ช่อง (ทุกแบบใช้ช่องขนาดเดียวกัน ต่างแค่ตำแหน่ง)
const CODE_PER_ROW = CODE_BITS / 2
const CODE_CELL = 4
const CODE_PITCH = 5.5

// ตารางช่องฝน 4 คอลัมน์ x 25 ข้อ
export const COLUMNS = 4
export const ROWS_PER_COLUMN = 25
export const MAX_BUBBLE_QUESTIONS = COLUMNS * ROWS_PER_COLUMN
const ROW_PITCH = 8
const BUBBLE_R = 2.4

// ---- กระดาษสำรอง: ช่องฝนเลขประจำตัวอยู่ในคอลัมน์ที่ 4 ของตารางคำตอบ ----
// ข้อ 1-75 อยู่ตำแหน่งเดิมทุกข้อ ตัวอ่านใช้ bubbleLayout ตัวเดียวกันได้ กระดาษสำรองจึงรับข้อปรนัย
// ได้ 3 คอลัมน์ ส่วนคอลัมน์ที่ 4 เป็นช่องเขียน + ช่องฝนเลข 5 หลัก (เลขประจำตัวนักเรียนเกือบทั้งหมด
// เป็นตัวเลข 5 หลัก — คนที่ไม่ใช่ ครูเลือกนักเรียนเองตอนสแกน)
export const ID_DIGITS = 5
export const SPARE_MAX_OBJECTIVE = (COLUMNS - 1) * ROWS_PER_COLUMN
// ระยะนับจากแถวแรกของตาราง (gridY0 ของแบบนั้น)
const ID_TITLE_DY = 0                       // บรรทัดหัว "เลขประจำตัว"
const ID_BOX_DY = 3                         // ช่องเขียนเลขด้วยมือ (ให้ครูเทียบกับที่ฝน)
const ID_BOX = 5.4
const ID_DY0 = 14                           // ศูนย์กลางแถวเลข 0
const ID_PITCH = 7

// คืน { titleX, titleY, boxes: [{x, y, size}], digits: [{ index, bubbles: [{ value, label, cx, cy, r }] }] }
export const idLayout = (version = LAYOUT_VERSION) => {
  const g = geo(version)
  const colX = g.gridX0 + (COLUMNS - 1) * g.columnWidth
  const digits = Array.from({ length: ID_DIGITS }, (_, d) => {
    const cx = colX + g.bubbleX0 + d * g.bubblePitch
    return {
      index: d,
      cx,
      bubbles: Array.from({ length: 10 }, (_, v) => ({
        value: String(v), label: String(v), cx, cy: g.gridY0 + ID_DY0 + v * ID_PITCH, r: BUBBLE_R,
      })),
    }
  })
  return {
    titleX: colX + 5,
    titleY: g.gridY0 + ID_TITLE_DY,
    boxes: digits.map((d) => ({ x: d.cx - ID_BOX / 2, y: g.gridY0 + ID_BOX_DY, size: ID_BOX })),
    digits,
  }
}

const CHOICE_LABELS = ['ก', 'ข', 'ค', 'ง', 'จ']
const TF_OPTIONS = [{ value: 'T', label: 'ถ' }, { value: 'F', label: 'ผ' }]

export const codeCells = (version = LAYOUT_VERSION) => {
  const g = geo(version)
  const x0 = g.codeCenterX - ((CODE_PER_ROW - 1) * CODE_PITCH + CODE_CELL) / 2
  return Array.from({ length: CODE_BITS }, (_, i) => ({
    index: i,
    x: x0 + (i % CODE_PER_ROW) * CODE_PITCH,
    y: g.codeY0 + Math.floor(i / CODE_PER_ROW) * CODE_PITCH,
    size: CODE_CELL,
  }))
}

// questions = [{ eq_no, eq_type }] เรียงตาม eq_no — คืนตำแหน่งเลขข้อและช่องฝนของข้อปรนัย
// spare = กระดาษสำรอง (คอลัมน์ที่ 4 เป็นช่องฝนเลขประจำตัว) — ตำแหน่งข้อเหมือนกระดาษปกติทุกข้อ ต่างแค่เพดาน
export const bubbleLayout = (questions, choices, spare = false, version = LAYOUT_VERSION) => {
  const g = geo(version)
  const objective = questions.filter((q) => q.eq_type === 'choice' || q.eq_type === 'truefalse')
  if (objective.length > MAX_BUBBLE_QUESTIONS) {
    throw new Error(`กระดาษหนึ่งแผ่นรับข้อปรนัยได้ไม่เกิน ${MAX_BUBBLE_QUESTIONS} ข้อ`)
  }
  if (spare && objective.length > SPARE_MAX_OBJECTIVE) {
    throw new Error(`กระดาษสำรองรับข้อปรนัยได้ไม่เกิน ${SPARE_MAX_OBJECTIVE} ข้อ (คอลัมน์สุดท้ายเป็นช่องฝนเลขประจำตัว)`)
  }
  return objective.map((q, i) => {
    const colX = g.gridX0 + Math.floor(i / ROWS_PER_COLUMN) * g.columnWidth
    const cy = g.gridY0 + (i % ROWS_PER_COLUMN) * ROW_PITCH
    const options = q.eq_type === 'truefalse'
      ? TF_OPTIONS
      : CHOICE_LABELS.slice(0, choices).map((label, k) => ({ value: String(k + 1), label }))
    return {
      eq_no: q.eq_no,
      eq_type: q.eq_type,
      numberX: colX + 8,
      cy,
      bubbles: options.map((o, k) => ({
        value: o.value,
        label: o.label,
        cx: colX + g.bubbleX0 + k * g.bubblePitch,
        cy,
        r: BUBBLE_R,
      })),
    }
  })
}
